export function initMenu($) {
  const $menu = $('[data-wb-menu]');
  const $toggle = $('[data-wb-menu-toggle]');
  const $toggleLabel = $('[data-wb-menu-label]');
  const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastFocusedElement = null;

  if (!$menu.length || !$toggle.length) {
    return;
  }

  const getFocusableItems = () => $menu.find(focusableSelector).filter(':visible');

  const closeMenu = () => {
    if (!$menu.hasClass('is-open')) {
      return;
    }

    $menu.removeClass('is-open').attr('aria-hidden', 'true');
    $toggle.attr('aria-expanded', 'false').attr('aria-label', 'Open menu');
    $toggleLabel.text('Open menu');
    $('body').removeClass('wb-menu-open');

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
    lastFocusedElement = null;
  };

  const openMenu = () => {
    if ($menu.hasClass('is-open')) {
      return;
    }

    lastFocusedElement = document.activeElement;
    $menu.addClass('is-open').attr('aria-hidden', 'false');
    $toggle.attr('aria-expanded', 'true').attr('aria-label', 'Close menu');
    $toggleLabel.text('Close menu');
    $('body').addClass('wb-menu-open');

    const $focusableItems = getFocusableItems();
    if ($focusableItems.length) {
      $focusableItems.first().trigger('focus');
    }
  };

  $toggle.on('click', () => {
    if ($menu.hasClass('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  $(document).on('keydown', (event) => {
    if (event.key === 'Escape' && $menu.hasClass('is-open')) {
      closeMenu();
    }
  });

  $menu.on('keydown', (event) => {
    if (event.key !== 'Tab' || !$menu.hasClass('is-open')) {
      return;
    }

    const $focusableItems = getFocusableItems();
    if (!$focusableItems.length) {
      return;
    }

    const firstElement = $focusableItems.get(0);
    const lastElement = $focusableItems.get($focusableItems.length - 1);

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  $menu.on('click', (event) => {
    if ($(event.target).is('[data-wb-menu]')) {
      closeMenu();
    }
  });

  $menu.on('click', 'a', () => {
    closeMenu();
  });
}
